// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.summary-card {
  border-radius: 0.5rem;
  box-shadow: 0 4px 6px rgba(2, 56, 121, 0.5);
  transition: transform 0.3s;
  cursor: pointer;
}

.summary-card:hover {
  transform: translateY(-5px);
}

.card-icon {
  font-size: 2rem;
  color: #fff;
  padding: 0.5rem;
  border-radius: 50%;
  background-color: #28a745;
  width: 50px;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.card-title {
  font-size: 16px;
  color: rgb(72, 71, 71);
}

.title {
  color: rgb(104, 104, 104);
  font-size: 24px;
}

.dashboard-container {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
}

.card {
  flex: 1;
  min-width: 280px;
  padding: 16px;
  box-shadow: 0 4px 6px rgba(2, 56, 121, 0.5);
  border-radius: 8px;
  background-color: #fff;
}

.card h2 {
  font-size: 1.25rem;
  font-weight: 500;
  margin-bottom: 16px;
}`, "",{"version":3,"sources":["webpack://./src/app/features/secure-blockchain/authoring-tools/dashboard/dashboard.component.scss"],"names":[],"mappings":"AAAA;EACE,qBAAA;EACA,2CAAA;EACA,0BAAA;EACA,eAAA;AACF;;AACA;EACE,2BAAA;AAEF;;AAAA;EACE,eAAA;EACA,WAAA;EACA,eAAA;EACA,kBAAA;EACA,yBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAGF;;AAAA;EACE,eAAA;EACA,sBAAA;AAGF;;AAAA;EACE,yBAAA;EACA,eAAA;AAGF;;AAAA;EACE,aAAA;EACA,eAAA;EACA,SAAA;AAGF;;AAAA;EACE,OAAA;EACA,gBAAA;EACA,aAAA;EACA,2CAAA;EACA,kBAAA;EACA,sBAAA;AAGF;;AAAA;EACE,kBAAA;EACA,gBAAA;EACA,mBAAA;AAGF","sourcesContent":[".summary-card {\n  border-radius: 0.5rem;\n  box-shadow: 0 4px 6px rgba(2, 56, 121, 0.5);\n  transition: transform 0.3s;\n  cursor: pointer;\n}\n.summary-card:hover {\n  transform: translateY(-5px);\n}\n.card-icon {\n  font-size: 2rem;\n  color: #fff;\n  padding: 0.5rem;\n  border-radius: 50%;\n  background-color: #28a745;\n  width: 50px;\n  height: 50px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.card-title {\n  font-size: 16px;\n  color: rgb(72, 71, 71);\n}\n\n.title {\n  color: rgb(104, 104, 104);\n  font-size: 24px;\n}\n\n.dashboard-container {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 16px;\n}\n\n.card {\n  flex: 1;\n  min-width: 280px;\n  padding: 16px;\n  box-shadow: 0 4px 6px rgba(2, 56, 121, 0.5);\n  border-radius: 8px;\n  background-color: #fff;\n}\n\n.card h2 {\n  font-size: 1.25rem;\n  font-weight: 500;\n  margin-bottom: 16px;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
